module.exports = __webpack_public_path__ + "img/2021_Cell.c5790096.png";